<template>
    <div class="container h-full bg-purple-900 relative">
        <div v-if="loading" class="flex justify-center items-center h-full">
            <div class="loader"></div>
        </div>

        <float-button class="m-10 bg-red-500" @click="deleteInstance()">
            <icon icon="times"></icon>
        </float-button>

        <div class="text-white overflow-y-auto h-full" @scroll="onScroll" ref="chats">
            <div v-if="!loading && !chats.length" class="flex justify-center items-center h-full">
                {{ $t('no_old_messages_found') }}
            </div>

            <div class="chats pt-12" v-if="chats.length && !loading">
                <div class="chat"
                     @click="loadConversations(chat.id)"
                     v-for="(chat, k) in chats" :key="k">

                    <img class="w-10 h-10 rounded-full mr-4"
                         @error="imageError"
                         :src="chat.image_url" :alt="chat.name">

                    <div class="text-sm flex-grow">
                        <p class="leading-none">
                            {{ chat.name || $t('unknown') }}
                        </p>

                        <p class="opacity-50" v-if="chat.last_message && chat.last_message.content && chat.last_message.content.text">
                            {{ chat.last_message.content.text }}
                        </p>
                    </div>

                    <div class="text-xs text-right">
                        {{ $filters.dt(chat.last_message_time, 'fromNow') }} <br>
                        {{ $t('at') }} {{ $filters.dt(chat.last_message_time, 'HH:mm') }}
                    </div>

                    <div class="text-lg text-right pl-5">
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .chat {
        @apply flex items-center border-b border-purple-400 border-opacity-25 p-4 cursor-pointer;
    }

    .chat:hover {
        @apply bg-purple-600;
    }
</style>

<script>
    import {Zapin} from '@/services/Api';

    export default {
        props: {
            id: String
        },

        data() {
            return {
                loading: false,
                processing: false,
                chats: [],
                scrollPos: 0,
                pagination: {
                    current_page: 0,
                    last_page: 1
                }
            }
        },

        mounted() {
            this.loadChats();
        },

        activated() {
            this.$refs.chats.scrollTop = this.scrollPos;
        },

        methods: {
            deleteInstance() {
                this.$router.push({
                    name: 'DeleteInstance',
                    params: {
                        id: this.id
                    }
                })
            },

            onScroll(e) {
                if(!e.target) return;

                this.scrollPos = e.target.scrollTop;

                if (e.target.offsetHeight + e.target.scrollTop >= (e.target.scrollHeight - 400) && !this.processing) {
                    this.loadChats();
                }
            },

            imageError(e) {
                e.target.src = '/images/unknown.jpg';
            },

            loadConversations(chatId) {
                this.$router.push({
                    name: 'InstanceConversation',
                    params: {
                        id: this.id,
                        chat: chatId
                    }
                })
            },

            loadChats() {
                if(this.pagination.current_page < this.pagination.last_page) {
                    this.processing = true;

                    if(this.pagination.current_page === 0) {
                        this.loading = true;
                    }

                    this.pagination.current_page++;

                    Zapin
                        .chats()
                        .paginate(this.id, this.pagination.current_page)
                        .then(res => {
                            this.pagination.last_page = res.meta.last_page;
                            this.chats = this.chats.concat(res.data);
                        })
                        .finally(() => {
                            this.loading = false;
                            this.processing = false;
                        });
                }
            },

            goBack() {
                history.go(-1);
            }

        }

    }
</script>